import { Component, type ErrorInfo, type ReactNode } from "react";

interface State {
  error: Error | null;
}

export default class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[ErrorBoundary]", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-ink-900 p-8 text-white">
          <div className="mx-auto max-w-3xl">
            <h1 className="font-display text-2xl font-bold mb-4">页面渲染出错</h1>
            <p className="mb-4 text-white/70 text-sm">
              请把下面的错误截图发给开发者：
            </p>
            <pre className="overflow-auto rounded-md bg-black/40 p-4 text-xs text-red-300 font-mono">
{this.state.error.message}{"\n\n"}{this.state.error.stack}
            </pre>
            <button
              onClick={() => { this.setState({ error: null }); window.location.href = "/"; }}
              className="mt-6 rounded-md bg-white/10 px-4 py-2 text-sm hover:bg-white/20"
            >
              返回首页
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
